module.exports = __webpack_public_path__ + "static/media/acceptSvg.b48ba43a.svg";